function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M45.061 9.868L36.1324 0.939427C36.0493 0.856566 35.9507 0.790891 35.8423 0.746156C35.7338 0.701421 35.6176 0.678503 35.5003 0.678712H14.336C13.5555 0.679658 12.8072 0.990257 12.2555 1.54233C11.7037 2.09441 11.3936 2.84284 11.3931 3.62336V16.7948C8.47954 17.0181 5.7577 18.3332 3.77199 20.477C1.78628 22.6208 0.683105 25.4352 0.683105 28.3573C0.683105 31.2794 1.78628 34.0938 3.77199 36.2376C5.7577 38.3813 8.47954 39.6964 11.3931 39.9198V42.3769C11.3936 43.1574 11.7037 43.9059 12.2555 44.4579C12.8072 45.01 13.5555 45.3206 14.336 45.3216H42.3717C42.7588 45.322 43.1421 45.2462 43.4999 45.0985C43.8577 44.9507 44.1828 44.7339 44.4568 44.4605C44.7308 44.187 44.9481 43.8623 45.0965 43.5047C45.2449 43.1472 45.3214 42.764 45.3217 42.3769V10.5001C45.3219 10.3828 45.299 10.2666 45.2542 10.1581C45.2095 10.0497 45.1438 9.95107 45.061 9.868ZM36.3931 3.72693L42.2735 9.60728H36.3931V3.72693ZM2.46454 28.3573C2.46454 26.4148 3.04055 24.5159 4.11975 22.9008C5.19894 21.2857 6.73284 20.0268 8.52747 19.2835C10.3221 18.5401 12.2969 18.3456 14.202 18.7246C16.1072 19.1035 17.8572 20.0389 19.2308 21.4125C20.6043 22.786 21.5397 24.536 21.9187 26.4412C22.2976 28.3464 22.1031 30.3211 21.3598 32.1158C20.6164 33.9104 19.3576 35.4443 17.7425 36.5235C16.1273 37.6027 14.2285 38.1787 12.286 38.1787C9.68203 38.1759 7.18556 37.1402 5.3443 35.2989C3.50304 33.4577 2.46737 30.9612 2.46454 28.3573ZM42.3788 43.5359H14.336C14.0289 43.5354 13.7346 43.4131 13.5176 43.1958C13.3007 42.9785 13.1788 42.684 13.1788 42.3769V39.9198C16.0924 39.6964 18.8142 38.3813 20.7999 36.2376C22.7856 34.0938 23.8888 31.2794 23.8888 28.3573C23.8888 25.4352 22.7856 22.6208 20.7999 20.477C18.8142 18.3332 16.0924 17.0181 13.1788 16.7948V3.62336C13.1788 3.3163 13.3007 3.02179 13.5176 2.8045C13.7346 2.58721 14.0289 2.4649 14.336 2.46443H34.6074V10.5001C34.6074 10.7369 34.7015 10.964 34.8689 11.1315C35.0364 11.2989 35.2635 11.393 35.5003 11.393H43.536V42.3769C43.536 42.684 43.4141 42.9785 43.1972 43.1958C42.9802 43.4131 42.6859 43.5354 42.3788 43.5359Z",
  fill: "url(#paint90_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M31.0357 10.5003C31.0357 10.2635 30.9417 10.0364 30.7742 9.86893C30.6068 9.70149 30.3797 9.60742 30.1429 9.60742H17.6429C17.4061 9.60742 17.179 9.70149 17.0115 9.86893C16.8441 10.0364 16.75 10.2635 16.75 10.5003C16.75 10.7371 16.8441 10.9642 17.0115 11.1316C17.179 11.2991 17.4061 11.3931 17.6429 11.3931H30.1429C30.3797 11.3931 30.6068 11.2991 30.7742 11.1316C30.9417 10.9642 31.0357 10.7371 31.0357 10.5003Z",
  fill: "url(#paint91_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M39.0718 14.9639H26.5718C26.335 14.9639 26.1079 15.0579 25.9405 15.2254C25.773 15.3928 25.679 15.6199 25.679 15.8567C25.679 16.0935 25.773 16.3206 25.9405 16.4881C26.1079 16.6555 26.335 16.7496 26.5718 16.7496H39.0718C39.3086 16.7496 39.5357 16.6555 39.7032 16.4881C39.8706 16.3206 39.9647 16.0935 39.9647 15.8567C39.9647 15.6199 39.8706 15.3928 39.7032 15.2254C39.5357 15.0579 39.3086 14.9639 39.0718 14.9639Z",
  fill: "url(#paint92_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M26.5718 22.108H28.3575C28.5943 22.108 28.8214 22.0139 28.9889 21.8465C29.1563 21.679 29.2504 21.4519 29.2504 21.2151C29.2504 20.9783 29.1563 20.7512 28.9889 20.5838C28.8214 20.4163 28.5943 20.3223 28.3575 20.3223H26.5718C26.335 20.3223 26.1079 20.4163 25.9405 20.5838C25.773 20.7512 25.679 20.9783 25.679 21.2151C25.679 21.4519 25.773 21.679 25.9405 21.8465C26.1079 22.0139 26.335 22.108 26.5718 22.108Z",
  fill: "url(#paint93_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M39.0715 20.3223H31.9286C31.6918 20.3223 31.4647 20.4163 31.2973 20.5838C31.1298 20.7512 31.0358 20.9783 31.0358 21.2151C31.0358 21.4519 31.1298 21.679 31.2973 21.8465C31.4647 22.0139 31.6918 22.108 31.9286 22.108H39.0715C39.3083 22.108 39.5354 22.0139 39.7028 21.8465C39.8703 21.679 39.9643 21.4519 39.9643 21.2151C39.9643 20.9783 39.8703 20.7512 39.7028 20.5838C39.5354 20.4163 39.3083 20.3223 39.0715 20.3223Z",
  fill: "url(#paint94_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M39.0718 25.6787H26.5718C26.335 25.6787 26.1079 25.7728 25.9405 25.9402C25.773 26.1077 25.679 26.3348 25.679 26.5716C25.679 26.8084 25.773 27.0355 25.9405 27.2029C26.1079 27.3704 26.335 27.4644 26.5718 27.4644H39.0718C39.3086 27.4644 39.5357 27.3704 39.7032 27.2029C39.8706 27.0355 39.9647 26.8084 39.9647 26.5716C39.9647 26.3348 39.8706 26.1077 39.7032 25.9402C39.5357 25.7728 39.3086 25.6787 39.0718 25.6787Z",
  fill: "url(#paint95_linear)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M39.0718 31.0352H26.5718C26.335 31.0352 26.1079 31.1292 25.9405 31.2967C25.773 31.4641 25.679 31.6912 25.679 31.928C25.679 32.1648 25.773 32.3919 25.9405 32.5594C26.1079 32.7268 26.335 32.8209 26.5718 32.8209H39.0718C39.3086 32.8209 39.5357 32.7268 39.7032 32.5594C39.8706 32.3919 39.9647 32.1648 39.9647 31.928C39.9647 31.6912 39.8706 31.4641 39.7032 31.2967C39.5357 31.1292 39.3086 31.0352 39.0718 31.0352Z",
  fill: "url(#paint96_linear)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M33.7147 36.3936H26.5718C26.335 36.3936 26.1079 36.4876 25.9405 36.6551C25.773 36.8225 25.679 37.0496 25.679 37.2864C25.679 37.5232 25.773 37.7503 25.9405 37.9178C26.1079 38.0852 26.335 38.1793 26.5718 38.1793H33.7147C33.9515 38.1793 34.1786 38.0852 34.346 37.9178C34.5134 37.7503 34.6075 37.5232 34.6075 37.2864C34.6075 37.0496 34.5134 36.8225 34.346 36.6551C34.1786 36.4876 33.9515 36.3936 33.7147 36.3936Z",
  fill: "url(#paint97_linear)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M39.0718 36.3936H37.286C37.0492 36.3936 36.8221 36.4876 36.6547 36.6551C36.4873 36.8225 36.3932 37.0496 36.3932 37.2864C36.3932 37.5232 36.4873 37.7503 36.6547 37.9178C36.8221 38.0852 37.0492 38.1793 37.286 38.1793H39.0718C39.3086 38.1793 39.5357 38.0852 39.7031 37.9178C39.8705 37.7503 39.9646 37.5232 39.9646 37.2864C39.9646 37.0496 39.8705 36.8225 39.7031 36.6551C39.5357 36.4876 39.3086 36.3936 39.0718 36.3936Z",
  fill: "url(#paint98_linear)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M17.6661 24.5612C17.4987 24.3938 17.2716 24.2998 17.0349 24.2998C16.7981 24.2998 16.5711 24.3938 16.4036 24.5612L10.7018 30.2612L8.16791 27.7255C8.00026 27.5581 7.77297 27.4641 7.53603 27.4643C7.2991 27.4645 7.07194 27.5587 6.90452 27.7264C6.7371 27.8941 6.64314 28.1213 6.64331 28.3583C6.64348 28.5952 6.73776 28.8224 6.90541 28.9898L10.0715 32.1541C10.2389 32.3215 10.466 32.4155 10.7027 32.4155C10.9395 32.4155 11.1666 32.3215 11.334 32.1541L17.6661 25.8237C17.8335 25.6563 17.9275 25.4292 17.9275 25.1925C17.9275 24.9557 17.8335 24.7287 17.6661 24.5612Z",
  fill: "url(#paint99_linear)"
});

var _ref12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint90_linear",
  x1: 5.01096,
  y1: 51.9751,
  x2: 47.1967,
  y2: -0.380216,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint91_linear",
  x1: 2.32139,
  y1: 56.479,
  x2: 10.9312,
  y2: -29.0003,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint92_linear",
  x1: 75.5076,
  y1: 68.3067,
  x2: 84.1166,
  y2: -17.1695,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint93_linear",
  x1: 36.8718,
  y1: 73.158,
  x2: 66.8013,
  y2: -1.13085,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint94_linear",
  x1: 83.3839,
  y1: 77.083,
  x2: 96.946,
  y2: -7.0748,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint95_linear",
  x1: 117.379,
  y1: 83.2394,
  x2: 125.989,
  y2: -2.23955,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint96_linear",
  x1: 138.322,
  y1: 90.7048,
  x2: 146.931,
  y2: 5.22861,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint97_linear",
  x1: 101.045,
  y1: 96.8632,
  x2: 114.607,
  y2: 12.7054,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint98_linear",
  x1: 76.2859,
  y1: 100.79,
  x2: 106.214,
  y2: 26.504,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint99_linear",
  x1: 1.02377,
  y1: 240.664,
  x2: 171.258,
  y2: -53.0967,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1ABB17"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})));

function SvgClosed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosed);
export default __webpack_public_path__ + "static/media/closed.fadd239c.svg";
export { ForwardRef as ReactComponent };